<template>
  <div
    class="title"
    :class="{
      white: fontColor === 'white',
      brown: fontColor === 'brown',
    }"
  >
    <img
      :src="require('@/assets/activityplace/lefthua_' + fontColor + '.svg')"
     
    />
    <span>{{ title }}</span>
    <img
      :src="require('@/assets/activityplace/righthua_' + fontColor + '.svg')"
     
    />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    // 文字颜色
    fontColor: {
      type: String,
      default: 'white',
      validator: value => ['white', 'brown'].indexOf(value) !== -1
    },
  },
}
</script>

<style lang="less" scoped>
.title {
  padding: 20px 0;
  text-align: center;
  img {
    display: inline-block;
    width: 22px;
    height: 36px;
  }
  span {
    display: inline-block;
    padding: 7px 10px;
    font-size: 36px;
    line-height: 36px;
    vertical-align: middle;
    font-weight: 600;
    color: #ffffff;
  }
  &.brown span {
    color: #742e00;
  }
}
</style>